module.exports = __webpack_public_path__ + "static/media/founder1.b97f5d48.jpg";